// extracted by mini-css-extract-plugin
var _1 = "ProfileUserInfoItem-modulecontainer__FRAw5";
export { _1 as "container" }
